module.exports = __webpack_public_path__ + "static/media/video.ae6cfbc3.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/video.webm
// module id = 280
// module chunks = 0